import React from 'react';
import Icon from '../../../components/AppIcon';

const CommissionBreakdown = ({ commissions }) => {
  const getLevelColor = (level) => {
    const colors = {
      1: 'var(--color-primary)',
      2: 'var(--color-accent)',
      3: 'var(--color-secondary)',
      4: '#10b981',
      5: '#8B4513'
    };
    return colors?.[level] || 'var(--color-muted)';
  };

  const getLevelName = (level) => {
    const names = {
      1: 'Venta Directa',
      2: '1ra Generación',
      3: '2da Generación',
      4: '3ra Generación',
      5: '4ta Generación'
    };
    return names?.[level] || `Nivel ${level}`;
  };

  const getLevelPercentage = (level) => {
    const percentages = {
      1: '10%',
      2: '2.5%',
      3: '1.5%',
      4: '0.6%',
      5: '0.4%'
    };
    return percentages?.[level] || '0%';
  };

  const totalCommission = commissions?.reduce((sum, c) => sum + c?.amount, 0) || 0;

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl md:text-2xl font-semibold text-foreground font-heading">
          Desglose de Comisiones
        </h3>
        <Icon name="PieChart" size={24} color="var(--color-primary)" />
      </div>
      <div className="space-y-4">
        {commissions?.map((commission) => {
          const percentageOfTotal = totalCommission > 0 ? (commission?.amount / totalCommission * 100) : 0;
          return (
            <div key={commission?.level} className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div 
                    className="w-3 h-3 rounded-full"
                    style={{ backgroundColor: getLevelColor(commission?.level) }}
                  />
                  <span className="text-sm font-medium text-foreground">
                    {getLevelName(commission?.level)} ({getLevelPercentage(commission?.level)})
                  </span>
                </div>
                <span className="text-sm font-semibold text-foreground data-text">
                  S/ {commission?.amount?.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
                <div 
                  className="h-full rounded-full transition-smooth"
                  style={{ 
                    width: `${percentageOfTotal}%`,
                    backgroundColor: getLevelColor(commission?.level)
                  }}
                />
              </div>
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span>{commission?.referrals} referidos activos</span>
                <span>{percentageOfTotal?.toFixed(1)}% del total</span>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <span className="text-base font-medium text-foreground">
            Total Comisiones
          </span>
          <span className="text-xl font-semibold text-primary data-text">
            S/ {totalCommission?.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CommissionBreakdown;